// extracted by mini-css-extract-plugin
export default {"files":"UploadComponent_files__FiFXI","selecthub":"UploadComponent_selecthub__dlE6M","hubs":"UploadComponent_hubs__JlYoB","link":"UploadComponent_link__rOCj6"};